import { quotaReceived } from './reducers';

export { quotaReceived };

export const QUOTA_RECEIVED = quotaReceived.type;
